<template>
	<section>
		<!--工具条-->
		<el-col :span="100" class="toolbar" style="padding-bottom: 0px;">
<!--		<el-col :span="100"  style="padding-bottom: 0px;">-->
			<el-form :inline="true" :model="filters">
        <el-form-item>
          <el-input
              v-model="filters.phone_number"
              placeholder="输入手机">
          </el-input>
        </el-form-item>

        <el-form-item>
          <el-input
              v-model="filters.account"
              placeholder="输入帐号">
          </el-input>
        </el-form-item>

        <el-form-item>
					<el-input
              v-model="filters.userName"
              placeholder="输入用户名">
          </el-input>
				</el-form-item>

        <el-form-item>
          <el-select
              v-model="filters.type"
              placeholder="请选择用户类型">
            <el-option
                v-for="item in typeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>

				<el-form-item>
					<el-button type="primary" v-on:click="handleSearch">查询</el-button>
				</el-form-item>
        <el-form-item>
          <el-button   type="primary" v-on:click="openDetailFormVisible">新增</el-button>
        </el-form-item>

        <el-form-item>
          <el-button   type="primary" v-on:click="getUserListExcel">导出</el-button>
        </el-form-item>

      </el-form>

		</el-col>

		<!--列表-->
		<el-table     v-if="userInfo"   :data="userInfo" highlight-current-row  v-loading="listLoading"   style="width:100%;"  :header-cell-style="{'text-align':'center'}">
			<el-table-column type="index"  width="40"></el-table-column>
      <el-table-column prop="phone_number" label="手机号" width="120" align="center" sortable></el-table-column>
      <el-table-column prop="account" label="帐号" width="60" align="center" sortable></el-table-column>
      <el-table-column prop="username" label="用户名" width="100" align="center" sortable></el-table-column>
      <el-table-column prop="passwd" label="密码" width="150" align="center"  sortable></el-table-column>
      <el-table-column prop="software_type" label="软件类型" width="100" align="center" :formatter="softwareTypeFormatter"></el-table-column>
      <el-table-column prop="type" label="用户类型" width="70" align="center" :formatter="typeFormatter"> </el-table-column>
      <el-table-column prop="buying_channels" label="渠道" width="70" align="center" :formatter="formatterBuying_channels"> </el-table-column>
      <el-table-column prop="group_name" label="微信群名" width="70" align="center" ></el-table-column>
      <el-table-column prop="effective_time" label="有效时间" width="100" align="center"  sortable>
        <template slot-scope="scope">
          <span>{{scope.row.effective_time.substring(0,10)}}</span>
        </template>
      </el-table-column>
<!--      <el-table-column prop="sn" label="机器码" width="150" align="center"  sortable></el-table-column>-->
      <el-table-column  label="状态" width="80" align="center"  >
        <template slot-scope="scope">
          <el-tag :type="scope.row.status === 0 ? 'danger' : 'success'" size="small">
            {{ scope.row.status === 0 ? '禁用' : '激活' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="create_date" label="创建时间" width="100" align="center"  sortable>
        <template slot-scope="scope">
          <span>{{scope.row.create_date.substring(0,10)}}</span>
        </template>
      </el-table-column>
<!--      <el-table-column prop="update_date" label="更新时间" width="100" align="center"  sortable>-->
<!--        <template slot-scope="scope">-->
<!--          <span>{{scope.row.update_date.substring(0,10)}}</span>-->
<!--        </template>-->
<!--      </el-table-column>-->
      <el-table-column prop="last_login_date" label="登录时间" width="100" align="center"  sortable>
        <template slot-scope="scope">
          <span>{{scope.row.last_login_date && typeof scope.row.last_login_date === 'string' ? scope.row.last_login_date.substring(0, 10) : ''}}</span>
        </template>
      </el-table-column>
<!--      <el-table-column prop="owner" label="创建人" width="80" align="center"  sortable></el-table-column>-->
<!--      <el-table-column prop="description" label="说明" min-width="100" align="center"  ></el-table-column>-->
			<el-table-column label="操作" width="300" align="center">
				<template slot-scope="scope">
					<el-button    size="small"
                        :type="scope.row.status === 1 ? 'warning' : 'success'"
                        @click="handleEditStatus(scope.$index, scope.row)">
                         {{ scope.row.status === 1 ? '禁用' : '激活' }}
          </el-button>
					<el-button    size="small" type="warning"  @click="handleEditReset(scope.$index, scope.row)">重置</el-button>
					<el-button    size="small" type="primary"  @click="handleUnlock(scope.row)">解锁</el-button>
					<el-button    size="small" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
					<el-button  type="danger" size="small" @click="handleDel(scope.$index, scope.row)">删除</el-button>
				</template>
			</el-table-column>

		</el-table>
    <div v-else>Loading...</div>



    <!--工具条-->
		<el-col :span="24" class="toolbar">
<!--			<el-button type="danger" @click="batchRemove" :disabled="this.sels.length===0">批量删除</el-button>-->
<!--			<el-pagination layout="prev, pager, next" @current-change="handleCurrentChange" :page-size="page_size" :total="total" style="float:right;">-->
<!--			</el-pagination>-->

      <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[20,30,50,100, 200, 500, 1000]"
          :page-size="page_size"
          layout="total, sizes, prev, pager, next"
          :total="total"
          >
      </el-pagination>
		</el-col>



    <!--详情界面-->
		<el-dialog title="用户详情" v-model="detailFormVisible" :close-on-click-modal="false" >
			<el-form :model="detailForm" label-width="80px" :rules="detailFormRules" ref="detailForm" width="200px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="帐号" prop="order_id">
              <el-input v-model="detailForm.account" auto-complete="off" readonly class="readonly-input"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="22">
            <el-form-item label="手机号">
              <el-input v-model="detailForm.phone_number"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

				<el-row>
  					<el-col :span="22">
  						<el-form-item label="用户名">
							<el-input v-model="detailForm.username"></el-input>
						</el-form-item>
  					</el-col>
				</el-row>
        <el-row>
          <el-col :span="22">
            <el-form-item label="软件类型">
              <el-select v-model="detailForm.software_type" placeholder="请选择软件类型">
                <el-option :value="1" label="人工贴标机"></el-option>
                <el-option :value="2" label="自动贴标机"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="22">
            <el-form-item label="用户类型">
              <el-select v-model="detailForm.type" placeholder="请选择用户类型" @change="handleTypeChange">
                <el-option
                    v-for="item in typeOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="22">
            <el-form-item label="密码">
              <el-input v-model="detailForm.passwd"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="22">
            <el-form-item label="有效期">
              <el-date-picker
                  v-model="detailForm.effective_time"
                  type="datetime"
                  placeholder="请选择有效期"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  :default-time="defaultTime">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="22">
            <el-form-item label="渠道类型">
              <el-select v-model="detailForm.buying_channels" placeholder="请选择渠道类型">
                <el-option
                    v-for="(label, value) in this.buying_channels"
                    :key="value"
                    :label="label"
                    :value="value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="22">
            <el-form-item label="微信群名">
              <el-input v-model="detailForm.group_name"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="22">
            <el-form-item label="说明">
              <el-input type="textarea" v-model="detailForm.description"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
			</el-form>


      <div slot="footer" class="dialog-footer"  >
        <el-button type="primary"   @click="saveUser">保存</el-button>

        <el-button   @click.native="detailFormVisible = false">返回</el-button>
			</div>

		</el-dialog>
	</section>


</template>

<script>
import util from "../../common/js/util";
import {
  getUserListPage,
  removeUser,
  batchRemoveUser,
  getOrderInfoListPage,
  getAllType,
  updateOrder,
  getOrderListExcelEx,
  postUpload,
  removeOrder,
  getTodayOrderSnCode,
  getBarcodeList,
  getSalesmanInfoPage,
  GetUserListInfo,
  saveSalesmanInfo,
  saveUserInfo,
  unlockUser,
  removeSalesman,
  GetUserListPage, getUserSn, getCustomersInfoSn, getUserListExcelEx

} from "../../api/api";

import {getLodop} from '../../LodopFuncs'
import {consignmentPrint} from '../../printModel'
import {hasPermission} from '../../premission'
import {dateToString} from '../../common/js/util'
import itemStyle from "echarts/src/model/mixin/itemStyle";

// import fileDownload from "js-file-download";



export default {
  data() {
    return {
      filters: {
        userName: "",
        account: "",
        phone_number: "",
        type: "",
      },
      orderInfo: [],
      page_size: 30,
      statusList:[],
      customs_clearance_typeList:[],
      payment_typeList:[],
      freight_typeList:[],
      total: 0,
      page: 1,
      init_order_id:'',
      order_sn:'',
      barcodeList:'',
      userInfo: null, // 初始值为 null
      listLoading: false,
      sels: [], //列表选中列

      detailFormVisible: false, //详情界面是否显示
      editLoading: false,
      detailFormRules: {
        name: [{ required: true, message: "请输入运单", trigger: "blur" }]
      },
      //详情界面数据
      detailForm: {
        id : 0,
        phone_number: "",
        software_type: 1,
        type: null,
        account: "",
        username: "",
        passwd: "",
        effective_time: "",
        description: "",
        buying_channels: "",
        group_name: "",
      },
      defaultTime: '00:00:00' ,// 默认时间为 00:00:00
      typeOptions: [
        { value: '', label: '全部' },
        { value: 10, label: '永久' },
        { value: 20, label: '订阅' },
        { value: 30, label: '试用' }
      ],
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      creation_date: '',
      value2: ''
    };
  },
  methods: {
    handleSearch() {
      this.page = 1;
      this.GetUserListInfo();
    },

    handleCurrentChange(val) {
      this.page = val;
      // this.page_size = val;
      this.GetUserListInfo();
    },

    handleSizeChange(val) {
      console.log(val)
      this.page = 1
      this.page_size = val;
      this.GetUserListInfo();
    },
    saveUser(){
      this.detailFormVisible = false;
      console.log('this.detailForm--')
      // this.detailForm.effective_time = this.formatDate(this.detailForm.effective_time)
      if (this.detailForm.effective_time instanceof Date) {
        this.detailForm.effective_time = this.formatDate(this.detailForm.effective_time)
      }
      saveUserInfo(this.detailForm).then(res => {
        this.listLoading = false;
        let msg = res.msg

        this.$message({
            message: msg,
            type: "success"
          });

        this.GetUserListInfo();

      });
    },
    limitMaxvalue(){
      if(this.detailForm.number > 999){
        this.detailForm.number = 1;
        this.$message("件数最多只能输入999");
      }
    },

    typeFormatter(row, column, cellValue) {
      switch (cellValue) {
        case 10:
          return '永久';
        case 20:
          return '订阅';
        case 30:
          return '试用';
        default:
          return '未知'; // 可选：处理未定义的类型
      }
    },

    softwareTypeFormatter(row, column, cellValue) {
      if (cellValue === 1 || cellValue === '1') return '人工贴标机';
      if (cellValue === 2 || cellValue === '2') return '自动贴标机';
      return '人工贴标机';
    },

    handleTypeChange(type) {
      //自动配置有效期
      const now = new Date();
      now.setHours(0, 0, 0, 0); // 设置为当天的 00:00:00
      let effectiveTime = '';

      switch (type) {
        case 10: // 永久
          effectiveTime = '9999-12-31 00:00:00';
          break;
        case 20: // 订阅，1 个月后
          now.setMonth(now.getMonth() + 1);
          effectiveTime = this.formatDate(now);
          break;
        case 30: // 试用，1 天后
          now.setDate(now.getDate() + 1);
          effectiveTime = this.formatDate(now);
          break;
        default:
          effectiveTime = ''; // 未选择时为空
      }

      // this.detailForm.effective_time = effectiveTime;
      this.$set(this.detailForm, 'effective_time', effectiveTime);
      console.log('effectiveTime----',effectiveTime)
    },
    formatDate(date) {
      const y = date.getFullYear();
      const m = String(date.getMonth() + 1).padStart(2, '0');
      const d = String(date.getDate()).padStart(2, '0');
      return `${y}-${m}-${d} 00:00:00`;
    },

    // formatter 函数，映射字段值
    formatterBuying_channels(row, column, cellValue) {
      // 使用 operation_type 对象来映射 'login' => '登录'
      return this.buying_channels[cellValue] || cellValue;
    },
    getAllTypeInfo() {
      this.listLoading = true;
      let para = {};
      //NProgress.start();
      getAllType(para).then(res => {
        this.buying_channels = res.data.buying_channels;
        this.user_type = res.data.user_type;

      });
    },

    sourceFormat(val,brandList) {
      // 可以输出看下 val 是什么，方便匹配；
      // :formatter="sourceFormat"    val 就应该是 val.processField
      let branchName = val
      brandList.forEach(item => {
        if(item.key == val) {
          branchName = item.value
          return branchName
        }
      })
      return branchName
    },



//获取列表
    GetUserListInfo() {
      //{"page":1,"pageSize":10,"project_name":null,"app_name":"web-uam.jar","created_by_name":null}
      let creation_date = []
      if (this.filters.creation_date != null){
        if(this.filters.creation_date[0] != null && this.filters.creation_date[1] != null) {
          creation_date[0] = dateToString(this.filters.creation_date[0]);
          creation_date[1] = dateToString(this.filters.creation_date[1]);
        }
      }
      let para = {
        page: this.page,
        pageSize: this.page_size,
        userName: this.filters.userName,
        account: this.filters.account,
        phone_number: this.filters.phone_number,
        type: this.filters.type,
      };
      console.log(para);
      this.listLoading = true;
      //NProgress.start();
      GetUserListPage(para).then(res => {

        let code = res.code
        let msg = res.msg
        // console.log(code)
        if (code != 0){
          this.$message(msg)
          this.$router.push({ path: '/login' });
        }
        this.total = res.data.pagintion.rowTotal;
        this.page_size = res.data.pagintion.pageSize;
        this.userInfo = res.data.result;
        this.listLoading = false;
        Vue.nextTick(() => {
          // 确保DOM更新完成后执行
          console.log('Table data loaded:', this.userInfo);
        });
      });
    },
    handleEditStatus: function(index, row) {

      let update_status
      let confirm_msg
      if (row.status == 0){
        update_status = 1;
        confirm_msg =  "确认激活【" +  row.account + "】帐号吗？"
      }else {
        update_status = 0;
        confirm_msg = "确认禁用【" + row.account + "】帐号吗？\n禁用后用户无法再登录"
      }

      this.$confirm(confirm_msg, "提示", {
        type: "warning"
      })
          .then(() => {
            this.listLoading = true;
            // console.log(row.order_id)
            //NProgress.start();
            let para = {
              account: row.account ,
              update_status: update_status
            };
            saveUserInfo(para).then(res => {
              this.listLoading = false;
              let code = res.code;
              let msg = res.msg

              if (code != 0) {
                // console.log(msg)
                this.$message({
                  message: msg,
                  type: "warning"
                });
              } else {
                this.$message({
                  message: msg,
                  type: "success"
                });
              }
              this.GetUserListInfo();
            });
          })
          .catch(() => {});
    },

    handleEditReset: function(index, row) {

      let sn
      let confirm_msg

      confirm_msg =  "确认重置【" +  row.account + "】 帐号吗？"

      this.$confirm(confirm_msg, "提示", {
        type: "warning"
      })
          .then(() => {
            this.listLoading = true;
            // console.log(row.order_id)
            //NProgress.start();
            let para = {
              account: row.account ,
              update_sn: 'reSet66666666'
            };
            saveUserInfo(para).then(res => {
              this.listLoading = false;
              let code = res.code;
              let msg = res.msg

              if (code != 0) {
                // console.log(msg)
                this.$message({
                  message: msg,
                  type: "warning"
                });
              } else {
                this.$message({
                  message: msg,
                  type: "success"
                });
              }
              this.GetUserListInfo();
            });
          })
          .catch(() => {});
    },





    //删除
    handleUnlock: function(row) {
      let confirm_msg = "确认解除【" + row.account + "】的登录锁定吗？";

      this.$confirm(confirm_msg, "提示", {
        type: "warning"
      })
        .then(() => {
          this.listLoading = true;
          return unlockUser({ account: row.account });
        })
        .then(res => {
          this.listLoading = false;
          this.$message({
            message: res.msg,
            type: res.code === 0 ? "success" : "warning"
          });
        })
        .catch(error => {
          this.listLoading = false;
          if (error && error.message) {
            this.$message.error(error.message);
          }
        });
    },

    handleDel: function(index, row) {
      let message =  "确认删除帐号【" + row.account + "】吗?"
      this.$confirm(message, "提示", {
        type: "warning"
      })
        .then(() => {
          this.listLoading = true;
          let para = { account: row.account,
            'enabled_flag' : 0};
            saveUserInfo(para).then(res => {
            this.listLoading = false;
            let code = res.code;
            let msg = res.msg

            if (code != 0) {
              // console.log(msg)
              this.$message({
                message: msg,
                type: "warning"
              });
            } else {
              this.$message({
                message: msg,
                type: "success"
              });
            }
            this.GetUserListInfo();
          });
        })
        .catch(() => {});
    },
    //显示详情界面
    handleEdit: function(index, row) {
      this.detailFormVisible = true;
      this.detailForm = Object.assign({}, row);
    },
    //显示详情界面



    openDetailFormVisible: function() {

      let para = {aa:"bb"}



      getUserSn(para).then(res => {

        let account = res.data.user_sn

        this.resetForm(account);

      });

      this.detailFormVisible = true;
      this.editMark = true;
    },

    openUpload: function() {
      this.upload = true;
    },

    resetForm(account) {
      //初始化表单

        // this.$refs[formName].resetFields();
        this.detailForm = {
          id: 0,
          account: account,
          passwd: "",
          username: "",
          description: "",
          software_type: 1,
        };
    },


    //导出列表
    getUserListExcel() {
      var ids = this.sels.map(item => item.id).toString()
      ids =9999
      let para = {
        ids: 99999,
        type: 'userList',
        data: ''
      };
      // console.log(ids)
      if (ids == ""){
        alert("未选中导出的记录，请选择后再【导出】")
        return  0
      }


      getUserListExcelEx(para).then(res => {
        this.listLoading = false
      });



    },



    // 上传文件
    onUpload (file) {
      let formData = new FormData()

      formData.append('file',file.file)
      postUpload(formData).then((res) => {
        formData.length = 0
        let count = res.data.data.count
        // console.log(formData)
        let msg =  "成功上传" + count + "条记录。"
        this.$message.success(msg)
        this.getOrderInfo();
        setTimeout(
            ()=>{
              location.reload();
            } , 3000)
      }).catch((e) => {
        this.$message.error(e.message)
      })
    },



      checkHasPermission: function(button_name,view_name) {
      return hasPermission(button_name,view_name);
    },

    selsChange: function(sels) {
      this.sels = sels;
    },
    //批量删除
    batchRemove: function() {
      var ids = this.sels.map(item => item.id).toString();
      this.$confirm("确认删除选中用户吗？", "提示", {
        type: "warning"
      })
        .then(() => {
          this.listLoading = true;
          let para = { ids: ids };
          batchRemoveUser(para).then(res => {
            this.listLoading = false;
            let { msg, code } = res.data;
            if (code !== 200) {
              this.$message({
                message: msg,
                type: "warning"
              });
            } else {
              this.$message({
                message: msg,
                type: "success"
              });
            }
            this.getUsers();
          });
        })
        .catch(() => {});
    }
  },
  mounted() {
    this.getAllTypeInfo();
    this.GetUserListInfo();

  }
};
</script>

<style scoped>

</style>

<style>
.readonly-input input {
  background-color: #f0f0f0; /* 设置背景颜色为灰色 */
  color: #999; /* 设置文字颜色为灰色 */
  cursor: not-allowed; /* 设置鼠标样式为禁止符号 */
}

.center {
  position: absolute;
  left: 50%;
  //top: 50%;
  transform: translate(-50%, -50%);
  width: 100px;
  height: 100px;
}

.el-dialog{
  width: 600px;
}
</style>



// WEBPACK FOOTER //
// userManage.vue?81fd9a9a